import { Mail, Twitter, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t border-border py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <div className="flex items-center space-x-4">
            <p className="text-muted-foreground text-sm">
              © 2025 SmartEQT™, Inc. All rights reserved.
            </p>
            <a
              href="mailto:info@smarteqt.net"
              className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-blue-600 transition-colors group"
            >
              <Mail className="h-4 w-4 transition-transform duration-200 group-hover:scale-110 group-hover:text-blue-600" />
              <span>info@smarteqt.net</span>
            </a>
            <Link 
              to="/privacy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
          </div>
          <div className="flex items-center space-x-4 mt-4 sm:mt-0">
            <a
              href="https://x.com/smarteqt"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-blue-600 transition-colors group"
              aria-label="Follow SmartEQT on X"
            >
              <Twitter className="h-5 w-5 transition-transform duration-200 group-hover:scale-110 group-hover:text-blue-600" />
            </a>
            <a
              href="https://www.instagram.com/smarteqt/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-blue-600 transition-colors group"
              aria-label="Follow SmartEQT on Instagram"
            >
              <Instagram className="h-5 w-5 transition-transform duration-200 group-hover:scale-110 group-hover:text-blue-600" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
